const faqAnimationDuration = 250;
const faqAnimationTiming = 'ease';

function initFaqItem(detail: HTMLDetailsElement) {
  const summary = detail.querySelector<HTMLElement>('.pdr-faq-item__summary');
  const body = detail.querySelector<HTMLElement>('.pdr-faq-item__body');
  let animation: Animation | null = null;

  if (!summary || !body) {
    return;
  }

  const finishAnimation = () => {
    animation = null;
    body.style.height = '';
    body.style.opacity = '';
  };

  summary.addEventListener('click', (event) => {
    event.preventDefault();
    animation?.cancel();

    if (detail.open) {
      const startHeight = body.offsetHeight;

      animation = body.animate(
        [
          { height: `${startHeight}px`, opacity: 1 },
          { height: '0px', opacity: 0 },
        ],
        {
          duration: faqAnimationDuration,
          easing: faqAnimationTiming,
        }
      );

      animation.addEventListener('finish', () => {
        detail.open = false;
        finishAnimation();
      });
      animation.addEventListener('cancel', finishAnimation);
      return;
    }

    detail.open = true;
    const endHeight = body.scrollHeight;

    animation = body.animate(
      [
        { height: '0px', opacity: 0 },
        { height: `${endHeight}px`, opacity: 1 },
      ],
      {
        duration: faqAnimationDuration,
        easing: faqAnimationTiming,
      }
    );

    animation.addEventListener('finish', finishAnimation);
    animation.addEventListener('cancel', finishAnimation);
  });
}

export function faq() {
  document.querySelectorAll<HTMLDetailsElement>('.pdr-faq-item').forEach(initFaqItem);
}
